import { useSignedInName } from "@/hooks/use-signed-in-name";

/**
 * The signed-in person at the head of the account menu and of Settings: their
 * name, their address beneath it when that says more, and their status.
 */
export function SignedInHeading({ status }: { status: string }) {
	const { name, email } = useSignedInName();
	return (
		<div className="flex min-w-0 flex-col space-y-1">
			<p className="break-all font-medium text-sm">{name}</p>
			{email ? (
				<p className="break-all text-muted-foreground text-xs">{email}</p>
			) : null}
			<p className="text-muted-foreground text-xs">{status}</p>
		</div>
	);
}
